<template>
  <div>
<div v-if="showModal" class="modal fade in" style="display: block;" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" @click="closeModal">&times;</button>
        <h4 class="modal-title text-center" v-html="title"></h4>
      </div>

      <!-- جسم المودال -->
      <div class="modal-body modal-body-flex">
        <!-- التابات -->
        <ul class="nav nav-tabs">
          <li class="active">
            <a href="#tab1" data-toggle="tab">البيانات</a>
          </li>
          <li>
            <a href="#tab2" :class="{ disabled: record.id === null }" data-toggle="tab" @click= "tabChange(1)">عقد فلتر</a>
          </li>
          <li>
            <a href="#tab3" :class="{ disabled: record.id === null || record.is_have_contract === 0 }" data-toggle="tab" @click= "tabChange(2)">عقود صيانه</a>
          </li>
          <li>
            <a href="#tab4" :class="{ disabled: record.id === null || record.is_have_contract === 0 }" data-toggle="tab" @click= "tabChange(3)">فواتير بيع</a>
          </li>
          <!-- <li>
            <a href="#tab6" :class="{ disabled: record.id === null || record.is_have_contract === 0 }" data-toggle="tab" @click= "tabChange(5)">أعمال الصيانة</a>
          </li> -->
          <!-- <li>
            <a href="#tab5" :class="{ disabled: record.id === null || record.is_have_contract === 0 }" data-toggle="tab" @click= "tabChange(4)">كشف حساب</a>
          </li> -->
          <li>
            <a href="#tab7" :class="{ disabled: record.id === null || record.is_have_contract === 0}" data-toggle="tab" @click= "tabChange(6)">سجل المكالمات</a>
          </li>
          <!-- <li>
            <a href="#tab8" :class="{ disabled: record.id === null || record.is_have_contract === 0 }" data-toggle="tab" @click= "tabChange(7)">الفواتير</a>
          </li> -->
          <li>
            <a href="#tab9" :class="{ disabled: record.id === null || record.is_have_contract === 0 }" data-toggle="tab" @click= "tabChange(8)">الجدولة</a>
          </li>
        </ul>

        <!-- محتوى التابات -->
        <div class="tab-content modal-scroll-content" style="margin-top: 15px;">
          <div class="tab-pane fade in active" id="tab1">
            <CustomerData ref="CustomerData" @return-data="returnData"> </CustomerData>
          </div>
          <div class="tab-pane fade" id="tab2">
            <Contracts ref="Contracts" @return-data="changeBlance"> </Contracts>
          </div>
          <div class="tab-pane fade" id="tab3">
            <Offers ref="Offers" @return-data="changeBlance"> </Offers>
          </div>
          <div class="tab-pane fade" id="tab4">
            <ItemSales ref="ItemSales"> </ItemSales>
          </div>
          <!-- <div class="tab-pane fade" id="tab5">
            <CustomerStatement ref="CustomerStatement"> </CustomerStatement>
          </div> -->
          <!-- <div class="tab-pane fade" id="tab6">
            <CustomerMaintenance ref="CustomerMaintenance"> </CustomerMaintenance>
          </div> -->
          <div class="tab-pane fade" id="tab7">
            <CustomerCalls ref="CustomerCalls"> </CustomerCalls>
          </div>
          <!-- <div class="tab-pane fade" id="tab8">
            <Invoices ref="Invoices"> </Invoices>
          </div> -->
          <div class="tab-pane fade" id="tab9">
            <MaintenanceSchedule ref="MaintenanceSchedule"> </MaintenanceSchedule>
          </div>
        </div>
    </div>
      <div class="modal-footer">
        <button class="btn btn-default" @click="closeModal">إغلاق</button>
      </div>

    </div>
  </div>
</div>
<div v-if="showModal" class="modal-backdrop fade in"></div>
</div>
</template>
<style scoped>
.nav-tabs .disabled {
pointer-events: none;
color: #aaa !important;
cursor: not-allowed;
}
/* امنع الصفحة الخلفية تتحرك */
body.modal-open {
overflow: hidden;
}

/* المودال كله */
.modal-dialog {
margin-top: 30px;
}

.modal-content {
display: flex;
flex-direction: column;
max-height: 90vh;   /* 👈 يحدد طول المودال */
}

/* جسم المودال */
.modal-body-flex {
display: flex;
flex-direction: column;
flex: 1;
min-height: 0;      /* 🔥 مفتاح السكرول */
}

/* التابات ثابتة */
.modal-body-flex > .nav-tabs {
flex-shrink: 0;
}

/* محتوى التابات هو اللي بيسكرول */
.modal-scroll-content {
flex: 1;
min-height: 0;      /* 🔥 مهم جدًا */
overflow-y: auto;
overflow-x: hidden;
}

</style>
<script>
import API from '@/store/api'
import Swal from 'sweetalert2'
import CustomerData from './CustomerData'
import Contracts from './Contracts'
import Offers from './Offers'
import ItemSales from './ItemSales'
// import CustomerStatement from './CustomerStatement'
// import CustomerMaintenance from './CustomerMaintenance'
import CustomerCalls from './CustomerCalls'
// import Invoices from '@/components/Sales/Invoice/Invoices'
import MaintenanceSchedule from './MaintenanceSchedule'

export default {
  name: 'CustomerDetails',
  components: {
    CustomerData,
    Contracts,
    Offers,
    ItemSales,
    // Invoices,
    // CustomerStatement,
    // CustomerMaintenance,
    MaintenanceSchedule,
    CustomerCalls
  },
  data () {
    return {
      isContractShow: false,
      isOfferShow: false,
      isItemSalesShow: false,
      isInvoicesShow: false,
      isCustomerStatementShow: false,
      isCustomerMaintenanceShow: false,
      isCustomerCallsShow: false,
      isMaintenanceScheduleShow: false,
      isLoadiningData: false,
      showModal: false,
      tabDisabled: true,
      record: '',
      title: '',
      branch: ''
    }
  },
  mounted () {
    document.addEventListener('keydown', this.handleEscape)
  },
  // ===========================================================================
  beforeDestroy () {
    document.removeEventListener('keydown', this.handleEscape)
  },
  methods: {
    closeModal () {
      this.showModal = false
    },
    // ===========================================================================
    handleEscape (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return

      // لو فيه مودال داخلي مفتوح (من Contracts)
      if (this.$refs.Contracts) {
        if (
          this.$refs.Contracts.showAddModal ||
          this.$refs.Contracts.showFreeItemsModal
        ) {
          return // ❌ ما تقفلش المودال الأساسي
        }
      }

      this.closeModal()
    },
    // ===========================================================================
    async setData (id, rec) {
      this.isContractShow = false
      this.isOfferShow = false
      this.isItemSalesShow = false
      this.isCustomerStatementShow = false
      this.isCustomerMaintenanceShow = false
      this.isCustomerCallsShow = false
      this.isMaintenanceScheduleShow = false
      this.isInvoicesShow = false
      this.record = []
      this.title = 'جارى تحميل البيانات'
      if (id === 0) {
        rec = {
          'id': null,
          'line_id': '',
          'branche_id': localStorage.getItem('BrancheID'),
          'rec_id': '',
          'name': '',
          'governorate': '',
          'city': '',
          'village': '',
          'address': '',
          'mobile': '',
          'mobile2': '',
          'idcard': '',
          'active': 1,
          'nickname': '',
          'evaluation': 0,
          'region_id': 0,
          'rec_id_letter': '',
          'location': '',
          'reviewType': 0,
          'is_have_contract': 0,
          'maintenance_group_id': ''
        }
        this.title = 'عميل جديد'
      } else {
        if (rec === null) {
          try {
            const data = await API.getCustomerData({
              id: id
            })
            rec = data
          } catch (err) {
            rec = null
          }
        }
      }
      // -----------------------------------------
      if (rec === null) {
        Swal.fire({
          position: 'fixed',
          icon: 'error',
          title: 'عفوا العميل غير موجود',
          showConfirmButton: false,
          timer: 3000
        })
      } else {
        this.showModal = true
        if (rec.rec_id > 0) {
          this.title = `<span style="color: #007bff;">عميل رقم [${rec.rec_id}]</span> - <span style="color: green;">${rec.name}</span>`
        }
        this.record = rec
        // -----------------------------------------
        setTimeout(() => {
          if (this.$refs.CustomerData) {
            this.$refs.CustomerData.pageLoad(rec)
          }
        }, 100) // Wait 100 milliseconds
      }
    },
    // ===========================================================================
    tabChange (id) {
      var branch = []
      var branches = JSON.parse(localStorage.getItem('Branches'))
      let i = branches.map(record => record.id).indexOf(parseInt(this.record.branche_id))
      if (i > -1) {
        branch = JSON.parse(JSON.stringify(branches[i]))
      }
      if (id === 1) {
        if (!this.isContractShow) {
          this.isContractShow = true
          this.$refs.Contracts.pageLoad(this.record.uid, branch, this.record.is_have_contract)
        }
      } else if (id === 2) {
        if (!this.isOfferShow) {
          this.isOfferShow = true
          this.$refs.Offers.pageLoad(this.record.uid, branch)
        }
      } else if (id === 3) {
        if (!this.isItemSalesShow) {
          this.isItemSalesShow = true
          this.$refs.ItemSales.pageLoad(this.record.uid, branch)
        }
      } else if (id === 4) {
        if (!this.isCustomerStatementShow) {
          this.isCustomerStatementShow = true
          // this.$refs.CustomerStatement.pageLoad(this.record.uid)
        }
      } else if (id === 5) {
        if (!this.isCustomerMaintenanceShow) {
          this.isCustomerMaintenanceShow = true
          // this.$refs.CustomerMaintenance.pageLoad(this.record.uid)
        }
      } else if (id === 6) {
        if (!this.isCustomerCallsShow) {
          this.isCustomerCallsShow = true
          this.$refs.CustomerCalls.pageLoad(this.record.uid, branch)
        }
      } else if (id === 7) {
        if (!this.isInvoicesShow) {
          this.isInvoicesShow = true
          // this.$refs.Invoices.pageLoad(this.record.uid, branch)
        }
      } else if (id === 8) {
        if (!this.isMaintenanceScheduleShow) {
          this.isMaintenanceScheduleShow = true
          this.$refs.MaintenanceSchedule.pageLoad(this.record.uid)
        }
      }
    },
    // ===========================================================================
    returnData (rec) {
      this.$emit('return-data', rec)
      this.record = rec
      this.title = `<span style="color: #007bff;">عميل رقم [${rec.rec_id}]</span> - <span style="color: green;">${rec.name}</span>`
    },
    // ===========================================================================
    changeBlance (balanceVlaue, rec) {
      this.record.is_have_contract = 1
      this.$emit('return-data', balanceVlaue, rec)
    },
    // ===========================================================================
    handleTabChange (tabIndex, newTab, oldTab) {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Customers/CustomerDetails.vue